<template>
  <div class="container column">
    <div class="relative martch_width mt10" style="height: 30px">
      <img src="../../assets/back.png" alt="" class="back" @click="back" />
      <span class="title">绑定支付宝</span>
    </div>

    <div class="t1 mt10">支付宝账号信息</div>

    <van-field
      v-model="info.relName"
      class="mt10"
      label="真实姓名"
      placeholder="请输入支付宝实名认证的姓名"
    />
    <van-field
      v-model="info.num"
      label="支付宝账号"
      placeholder="请输入支付宝账号（手机号/邮箱）"
    />
    <van-field
      v-model="info.identity"
      label="身份证号"
      placeholder="请输入支付宝实名认证的身份证号"
    />

    <div class="t1 mt10">账号验证</div>
    <van-field
      v-model="info.phone"
      class="mt10"
      label="手机号"
      type="number"
      disabled
    />
    <van-field
      v-model="info.phoneCode"
      center
      clearable
      label="短信验证码"
      placeholder="请输入短信验证码"
    >
      <template #button>
        <van-button size="small" type="primary" :disabled="coding" @click="sendSMS">{{ btnText }}</van-button>
      </template>
    </van-field>

    <div class="btn" style="margin: 16px">
      <van-button block
       :disabled="!(info.identity&&info.num&&info.phoneCode&&info.relName)"
        type="info" native-type="submit"
        @click="bindInfo">确认绑定</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  data() {
    return {
      info: {
        relName: "",
        num: "",
        identity: "",
        phone: this.$store.state.userInfo.phone,
        phoneCode: "",
      },
      isUpdate:false,
      coding: false,
      btnText: "发送验证码",
      codeTime: 60,
    };
  },
  mounted() {
    this.onload();
  },
  methods: {
    onload() {
      this.$request.GET({
        url: "agent/withdrawal",
        success: (obj) => {
          if(obj){
            this.isUpdate = true;
            this.info = obj;
            this.info.phone =  this.$store.state.userInfo.phone
          }
          
        },
      });
    },

    bindInfo(){
      this.$request.POST({
        url:this.isUpdate?'agent/withdrawal/update':'agent/withdrawal',
        data:this.info,
        success:(obj)=>{
          this.back();
        }
      })
    },

    back() {
      this.$router.back();
    },

    sendSMS() {
      if (!this.info.phone || this.coding) {
        return;
      }
      this.$request.GET({
        url: "verification",
        params: { phone: this.info.phone },
        success: (obj) => {
          this.coding = true;
          Toast("验证码发送成功");
          this.startTimer();
        },
      });
    },

    startTimer() {
      setTimeout(() => {
        this.codeTime--;
        if (this.codeTime <= 0) {
          this.btnText = "发送验证码";
          this.codeTime = 60;
          this.coding = false
        }else{
          this.btnText = this.codeTime+"s后重发"
          this.startTimer();
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.container {
  height: 100%;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  background: #f2f2f2;
}
.martch_width {
  width: 100%;
}
.relative {
  position: relative;
}
.column {
  display: flex;
  flex-direction: column;
}
.column_cent {
  justify-content: center;
}
.row_cent {
  align-items: center;
}
.row {
  display: flex;
  flex-direction: row;
}
.btn {
  height: 30px;
}

.mt10 {
  margin-top: 10px;
}
.back {
  position: absolute;
  left: 10px;
  width: 10px;
  height: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}
.title {
  position: absolute;
  left: 0;
  right: 0;
  color: black;
  font-size: 17px;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 30px;
}

.t1 {
  font-size: 12px;
  color: #666666;
  text-align: left;
  margin-left: 10px;
}
</style>